// extracted by mini-css-extract-plugin
export default {"product-gallery":"ProductGallery_product-gallery__Hgw+T"};